import { useError, useFetch, useRecaptcha } from '@ztechapps/common.hook'
import { useContext } from './context'
import { isValidEmail, isValidPhoneNumber } from '@ztechapps/common.utils'
import { useState } from 'react'

export const useSendCode = (): [() => Promise<void>, { error: any; loading: boolean }] => {
  const { recaptchaSiteKey, url, ...context } = useContext()
  const { getToken } = useRecaptcha({ recaptchaSiteKey })
  const [fetchNow, { error }] = useFetch(url)
  const { onError } = useError()
  const [loading, setLoading] = useState(false)

  const [, setShowCodeInput] = context.showCodeInput
  const [, setRequestId] = context.requestId
  const [, setErrorMessage] = context.errorMessage

  const onSendCode = async () => {
    try {
      setLoading(true)

      setErrorMessage(null)
      const destination = context.destination[0]
      //if this is not a valid email, it should be phone number then
      if (!isValidEmail(destination)) {
        if (!isValidPhoneNumber(destination)) {
          throw new Error(`Invalid phone number format. You might want to include the country code and leading '+' sign.`)
        }
      }

      const token = await getToken()
      const { requestId, error } = await fetchNow({
        destination,
        recaptchaToken: token,
      })

      if (error) {
        throw error
      }

      setRequestId(requestId)
      setShowCodeInput(true)
    } catch (e) {
      setErrorMessage(onError(e))
    } finally {
      setLoading(false)
    }
  }

  return [onSendCode, { error, loading }]
}
